<!-- 采购验收审核 -->
<template>
	<div class='page_content'>
		<processAuditAction  ref="processAuditAction"></processAuditAction>
		<subComponents  ref="showSelectData"></subComponents>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary"  size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				
				
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
					
					<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
						<el-input v-if="formOneValue.entityField == 'pscamBuycus'" @focus="$refs['showSelectData'].openBox('supplierList','pscamBuycus','')"
							v-model.trim="getRequestData.smName" clearable  :maxlength="$store.state.inputLength">
						</el-input>
						<el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
						<el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
					</el-form-item>
				
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table v-if="pageShowData[1]" stripe :data="returnData.list" border height="100%"  style="width: 100%" highlight-current-row size="mini">
				<el-table-column label="选择操作"  width="90">
					<template  slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column type="expand" label="详情" width="70">
				    <template slot-scope="props">
						<!-- 辅助信息 -->
						<el-tabs type="border-card">
							<el-tab-pane v-if="pageShowData[2]" :label="pageShowData[2].jciName">
								<el-table  :data="[props.row.pisOrderauxinf]"  border  style="width: 100%" size="mini">
									<el-table-column
										v-if="tableValye.isShow==1" 
										v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable" 
										:key="tableKey" 
                                        show-overflow-tooltip
                                        :min-width="tableValye.fieldWeight"
										:prop="tableValye.entityField"  
										:label="tableValye.showField"  >
										<template  slot-scope="scope">
											<span v-if="tableValye.fieldType == 'date'">
												<span v-if="scope.row[tableValye.entityField]">
													{{$common.getLocalTime(scope.row[tableValye.entityField])}}
												</span>
											</span>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                            </span>
											<span v-else>
												{{scope.row[tableValye.entityField]}}
											</span>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
							<!-- 明细信息 -->
							<el-tab-pane v-if="pageShowData[3]" :label="pageShowData[3].jciName">
								<el-table :data="props.row.pschaDetailMergeVos"  border style="width: 100%" size="mini">
									<el-table-column
										v-if="tableValye.isShow==1" 
										v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable" 
										:key="tableKey" 
                                        show-overflow-tooltip
                                        :min-width="tableValye.fieldWeight"
										:prop="tableValye.entityField"  
										:label="tableValye.showField"  >
										<template  slot-scope="scope">
											<span v-if="tableValye.fieldType == 'date'">
												<span v-if="scope.row[tableValye.entityField]">
													{{$common.getLocalTime(scope.row[tableValye.entityField])}}
												</span>
											</span>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                            </span>
											<!-- 是否双人验收 -->
											<el-tag size="mini" v-else-if="tableValye.entityField == 'bgiIsdcheck'">
												{{scope.row[tableValye.entityField] == 0 ?'否':'是'}}
											</el-tag>
											<span v-else>
												{{scope.row[tableValye.entityField]}}
											</span>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
						</el-tabs>
				    </template>
				</el-table-column>
				<el-table-column
					v-if="tableValye.isShow==1"
					v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" 
					:key="tableKey" 
                    show-overflow-tooltip
                    :min-width="tableValye.fieldWeight"
					:prop="tableValye.entityField"  
					:label="tableValye.showField">
					<template  slot-scope="scope">
						<span v-if="tableValye.fieldType == 'date'">
							{{$common.getLocalTime(scope.row[tableValye.entityField])}}
						</span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                        </span>
						<el-tag size="mini" v-else-if="tableValye.entityField == 'pscamState'">{{$common.getIsGsp(tableValye.formatterContent,scope.row.pscamState)}}</el-tag>
						<span v-else>
							{{scope.row[tableValye.entityField]}}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			
			getRequestData:{
				pscamBuycus:'',
				smName:'',
				page:1,
				rows:30,
				start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			buttonList:[],
			
			pageShowData:[],
			formDataList:[],
			
			selectedDataIndex:0,
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.smName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.pscamBuycus = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
           if (orderId) {
               // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {isPenetrate} //参数
                }, '*');
           }
        },
		isShowData(name,value){
			console.log(name)
			switch(name){
				case 'pscamBuycus':
					var dataInfo = sessionStorage.getItem('selectSupplierData')
					// console.log(dataInfo)
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.pscamBuycus = dataInfo.smId
						this.getRequestData.smName = dataInfo.smName
						
					}
					break;
				default :
					this.sendDataInfo[name] = value
				
			}
			
		},
		
		
		
		// 获取数据列表
		async getPageInfo(){
			var pathId = parent.getMenuInfo(this.$route.path)
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
				this.formDataList = []
				this.formDataList.push(this.pageShowData[4])
				this.formDataList.push(this.pageShowData[5])
				this.formDataList.push(this.pageShowData[6])
				if(this.formDataList.length>3){
					this.pageShowData[7].isShowForm = 1
					this.formDataList.push(this.pageShowData[7])
				}
				
				console.log(responseData.result)
			
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selecDataAction(data){
			this.selectedDataList =  data
		},
		selectDetailsction(data){
			this.selectDetails =  data
		},

	
		
	
		// 动作集合
		actionSet(actionData){
			switch(actionData.actionType){
				case 0:
					this.$refs['purchaseAcceptanceAction'].openBox(0,this.formDataList,'','')
					break;
				case 1:
					if(!this.returnData.list[this.selectedDataIndex]){
						this.$message({
							message: '请先选择您要操作的数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
					this.$refs['purchaseAcceptanceAction'].openBox(1,this.formDataList,dataInfo)
					break;
				case 2:
					this.delDataAction()
					break;
				case 3:
					this.submitData()
					break;
				case 4:
					if(!this.returnData.list[this.selectedDataIndex]){
						this.$message({
							message: '请先选择您要操作的数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
					this.$refs['processAuditAction'].openBox(0,dataInfo.pscamId)
					break;
				case 5:
					if(!this.returnData.list[this.selectedDataIndex]){
						this.$message({
							message: '请先选择您要操作的数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
					this.$refs['processAuditAction'].openBox(1,dataInfo.pscamId)
					break;
			}
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getPurchaseAcceptanceTask(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataIndex =0
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
		// 提交审核
		submitData(){
			if(!this.returnData.list[this.selectedDataIndex]){
				this.$message({
					message: '请先选择您要操作的数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo =this.returnData.list[this.selectedDataIndex]
			this.$confirm('确定要提交审核吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async()=> {
				var delData = {
					ids:[dataInfo.pscamId]
				}
				let responseData =  await this.$http.submitPurchaseAcceptance(delData)
				if(responseData.status == 200){
					this.$message({
						type: 'success',
						message: '操作成功!'
					});
					
					this.getDataList()
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				
			}).catch(() => {});
			
		},
		
		// 删除数据
		delDataAction(){
			if(!this.returnData.list[this.selectedDataIndex]){
				this.$message({
					message: '请先选择您要操作的数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo =this.returnData.list[this.selectedDataIndex]
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async()=> {
				var delData = {
					ids:[dataInfo.pscamId]
				}
				let responseData =  await this.$http.delPurchaseAcceptance(delData)
				if(responseData.status == 200){
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					
					this.getDataList()
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				
			}).catch(() => {});
			
		},
		//获取状态
		getIsGsp(str,val){
			try{
				str && str.replace(/\\/g,'')
				let arr = JSON.parse(str)
				let len = arr.length
				let newStr = ''
				for (let i = 0; i < len; i++) {
					if(arr[i].key === val){
						newStr = arr[i].value
						break;
					}
				}
				return newStr
			}catch(ex){
				return str
			}
		},
		
	
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
		
	
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getPageInfo()
		this.getDataList()
		this.getButtonList()
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
